var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"DealDetailsTogglerButton elevationShadow--1",attrs:{"size":"small"},on:{"click":_vm.toggle}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }